export default __webpack_public_path__ + "static/media/check-in-cn.64063bf6.gif";